import { LayoutDashboard, FileText, Users, Briefcase, FileCheck, Receipt, UserCog, Bell, ShieldCheck, ShieldAlert, CalendarDays, BookOpen, FileSignature, Building2, Zap, AlertTriangle } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import AiChat from '@/components/shared/AiChat';
import WorkspaceShell from './WorkspaceShell';

type AdminRole = 'SUPER_ADMIN' | 'ADMIN' | 'COMMERCIAL' | 'OPERATIONS';

const ROLE_LABELS: Record<AdminRole, { label: string; color: string }> = {
  SUPER_ADMIN: { label: 'Super Admin',  color: '#7c3aed' },
  ADMIN:       { label: 'Admin',        color: '#B8960A' },
  COMMERCIAL:  { label: 'Commercial',   color: '#ea580c' },
  OPERATIONS:  { label: 'Opérations',   color: '#0891b2' },
};

const navItems: { to: string; icon: typeof LayoutDashboard; label: string; roles?: AdminRole[] }[] = [
  { to: '/app/admin/dashboard', icon: LayoutDashboard, label: 'Tableau de bord' },
  { to: '/app/admin/missions',  icon: FileText,        label: 'Missions',       roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATIONS'] },
  { to: '/app/admin/clients',   icon: Briefcase,       label: 'Clients (CRM)',  roles: ['SUPER_ADMIN', 'ADMIN', 'COMMERCIAL'] },
  { to: '/app/admin/juristes',  icon: Users,           label: 'Juristes',       roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATIONS'] },
  { to: '/app/admin/quotes',    icon: FileCheck,       label: 'Devis',          roles: ['SUPER_ADMIN', 'ADMIN', 'COMMERCIAL'] },
  { to: '/app/admin/invoices',  icon: Receipt,         label: 'Factures',       roles: ['SUPER_ADMIN', 'ADMIN', 'COMMERCIAL'] },
  { to: '/app/admin/calendar',        icon: CalendarDays, label: 'Calendrier' },
  { to: '/app/admin/users',          icon: UserCog,     label: 'Utilisateurs',   roles: ['SUPER_ADMIN', 'ADMIN'] },
  { to: '/app/admin/audit',          icon: ShieldCheck,  label: 'Journal d\'audit',    roles: ['SUPER_ADMIN', 'ADMIN'] },
  { to: '/app/admin/anomalies',      icon: AlertTriangle, label: 'Anomalies',           roles: ['SUPER_ADMIN', 'ADMIN'] },
  { to: '/app/admin/login-history',  icon: ShieldAlert,  label: 'Connexions',           roles: ['SUPER_ADMIN', 'ADMIN'] },
  { to: '/app/admin/lexbase',         icon: BookOpen,    label: 'VaegBase Vivant', roles: ['SUPER_ADMIN', 'ADMIN', 'OPERATIONS'] },
  { to: '/app/admin/lexcreate',       icon: Building2,   label: "Création d'entreprise", roles: ['SUPER_ADMIN', 'ADMIN', 'COMMERCIAL', 'OPERATIONS'] },
  { to: '/app/admin/signatures',      icon: FileSignature, label: 'Habilitations Signature', roles: ['SUPER_ADMIN', 'ADMIN'] },
  { to: '/app/admin/feature-flags',  icon: Zap,           label: 'Fonctionnalités IA',      roles: ['SUPER_ADMIN'] },
  { to: '/app/admin/notifications',  icon: Bell,        label: 'Notifications' },
];

export default function AdminLayout() {
  const { user, activeRole } = useAuthStore();
  const role = (activeRole ?? user?.role ?? 'ADMIN') as AdminRole;
  const visibleNav = navItems.filter(item => !item.roles || item.roles.includes(role));
  return <WorkspaceShell title={ROLE_LABELS[role]?.label ?? 'Administration'} items={visibleNav} quickPaths={['dashboard', 'missions', 'clients', 'calendar']}><AiChat /></WorkspaceShell>;
}
